// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

var Types = {};

var fragmentConverter = {};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

function planFeature_decode($$enum) {
  if ($$enum === "SHARE_WITH_CLIENT" || $$enum === "PROPERTY_DETAILS" || $$enum === "INITIATE_PROPERTY_CONVERSATION" || $$enum === "HIDE_PROPERTY" || $$enum === "GNS" || $$enum === "FULL_AGENT_PAGE" || $$enum === "FORWARD_PROPERTY_EMAIL" || $$enum === "CLIENT_ACCESS" || $$enum === "VIEWING_AGENT") {
    return $$enum;
  }
  
}

function planFeature_fromString(str) {
  return planFeature_decode(str);
}

function planHandleV5_decode($$enum) {
  if ($$enum === "PRO_TRIAL" || $$enum === "PRO_QUARTERLY" || $$enum === "PRO_MONTHLY" || $$enum === "PRO_FREE" || $$enum === "FREE" || $$enum === "COMPLIMENTARY" || $$enum === "PRO_YEARLY") {
    return $$enum;
  }
  
}

function planHandleV5_fromString(str) {
  return planHandleV5_decode(str);
}

function planType_decode($$enum) {
  if ($$enum === "PRO" || $$enum === "FREE" || $$enum === "COMPLIMENTARY" || $$enum === "PRO_ONLY") {
    return $$enum;
  }
  
}

function planType_fromString(str) {
  return planType_decode(str);
}

var Utils = {
  planFeature_decode: planFeature_decode,
  planFeature_fromString: planFeature_fromString,
  planHandleV5_decode: planHandleV5_decode,
  planHandleV5_fromString: planHandleV5_fromString,
  planType_decode: planType_decode,
  planType_fromString: planType_fromString
};

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "throwOnFieldError": true,
    "catchTo": "RESULT"
  },
  "name": "UserSessionPlansFeatures_plan",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "features",
      "storageKey": null
    },
    {
      "alias": "type_",
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "handle",
      "storageKey": null
    }
  ],
  "type": "SubscriptionPlanV5",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
